<template>
  <div class="points-map w-lg-75">
    <h2 class="points-map__title">Wiesz, gdzie rośnie nawłoć?<br>
      Dołącz do patrolu i dodaj ją do mapy!</h2>
      <div class="points-map__content mb-3">Po dodaniu stanowiska nawłoci, otrzymasz od nas <strong>przypomnienie sms lub mailowe</strong>, gdy będzie odpowiedni moment na jej usunięcie wraz z <strong>radami, jak zrobić to skutecznie.</strong></div>
        
    <l-map style="height: 400px; width:100%" :zoom="zoom" :center="center" v-if="showMap">
      <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>

      <l-marker v-for="marker in markers" :key="marker.id" :lat-lng="marker.latLng" :attribution="attribution">
        <l-icon iconUrl="https://cdn.rawgit.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-green.png" shadowUrl="https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.3.1/images/marker-shadow.png" 
        
          ></l-icon>
        <l-popup>
          Nawłoć jest tu: {{ marker.latLng }}
        </l-popup>
      </l-marker>
    </l-map>
   
   
  
    <Form />
 

  </div>
</template>

<script>
import 'leaflet/dist/leaflet.css';
import axios from 'axios';
import { LMap, LTileLayer, LMarker, LPopup, LIcon } from 'vue2-leaflet';
import Form from '@/components/Form';

export default {
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
    LIcon,
    Form,
  },
  data() {
    return {
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      attribution:
        '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      zoom: 6,
      center: [52.303, 20.710],
      markerLatLng: [51.504, -0.159],
      markers: [
        { id: 1, latLng: [52.303, 20.710] },
        { id: 2, latLng: [51.302, 20.715] },
        { id: 3, latLng: [54.305, 20.720] },
      ],
      showMap: false,

    };
  },
  mounted: function() {
    this.loadMarkers();
  },
  methods: {
    loadMarkers() {
          axios.get('https://bogini2.greenpeace.pl/api/v1/lead-campaigns/nawloc/context')          
            .then(response => {
              this.markers = response.data.map((marker, index) => { 
                if (marker.context?.mappoints && marker.context.mappoints.length > 0) {
                  return {
                    id: index +1,
                    latLng: [marker.context.mappoints[0].lat, marker.context.mappoints[0].lng]
                  };
                }
              } 
            );
            this.showMap = true;
            })
            .catch(error => {
              console.error("Error loading markers:", error);
              this.markers = [];
              this.showMap = true;
            });
        },
   
  }

}
</script>
